<template>
    <div class="notification" v-bind:class="classes">
        <button class="dismiss fa fa-close" @click.prevent="hide"></button>
        <div class="timer" v-if="this.lifetime">
            <div
                class="inner"
                v-bind:style="{ width: lifeProgress + '%' }"
            ></div>
        </div>
        <span :class="icon"></span>
        <div class="notification-body">
            <slot name="text"></slot>
            <button
                v-if="actionLabel"
                type="button"
                class="notification-action"
                @click.prevent="runAction"
            >
                {{ actionLabel }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "notification",
    props: {
        type: String,
        lifetime: {
            // In milliseconds, 0 to always visible
            type: Number,
            default: 3500,
        },
        actionLabel: {
            type: String,
            default: null,
        },
        onAction: {
            type: Function,
            default: null,
        },
    },
    data: () => ({
        visible: false,
        createdOn: 0,
        lifeProgress: 0,
        actionUsed: false,
    }),
    computed: {
        icon() {
            switch (this.type) {
                case "success":
                    return "icon-check-alt";
                case "warning":
                    return "icon fa fa-exclamation";
                case "loading":
                    return "icon fa fa-clock-o";
                case "error":
                    return "icon fa fa-times close-icon";
                default:
                    return "";
            }
        },
        classes() {
            let classes = {};
            classes[this.type] = true;
            classes.visible = this.visible;
            return classes;
        },
    },
    mounted() {
        /*
         * This is required so the animation div is actually added to the DOM without the `visible` class
         * and then receives the `visible` class asap triggering the CSS animation.
         * Without it the div would be added with the `visible` class from the beginning and the CSS animation wouldn't be triggered
         */
        window.requestAnimationFrame(() => {
            this.createdOn = Date.now();
            this.visible = true;
            this.calcLifeProgress();
        });
    },
    methods: {
        calcLifeProgress() {
            let now = Date.now();
            if (!this.createdOn || this.lifetime === 0) {
                this.lifeProgress = 0;
            } else if (now - this.createdOn > this.lifetime) {
                this.lifeProgress = 100;
                this.hide();
            } else {
                let elapsedTime = now - this.createdOn;
                this.lifeProgress = Math.ceil(
                    (elapsedTime / this.lifetime) * 100,
                );
                window.setTimeout(() => {
                    this.calcLifeProgress();
                }, 20);
            }
        },
        runAction() {
            if (this.actionUsed) {
                return;
            }
            this.actionUsed = true;
            if (typeof this.onAction === "function") {
                this.onAction();
            }
            this.hide();
        },
        hide() {
            this.visible = false;
        },
    },
};
</script>
